import { PlusOutlined } from "@ant-design/icons";
import { Button, Select, Skeleton, Space, Typography } from "antd";
import {
  FC,
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

//!STYLES
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios, { AxiosResponse } from "axios";
import AppResult from "components/appResults";
/* import HelpPopover from "components/help"; */
import useWebhook from "hooks/useWebHook";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { displayDrawer, displayDrawerAdsSpecific } from "store/adventissements";
import { setIsCalendarUpdated, setUserHavingCalendar } from "store/app/appSlice";
import DrawerAdsCreneauSpecific from "../components/availabilitySpecific/drawer";
import CardCreneau from "./card";
import TeacherCalendarDetails from "./drawerDetails";
import s from "./style.module.css";

//!IMAGES
import { isToday, StatusCode } from "common/enums";
import SessionsCalendarGridView from "components/classroomComponents/SessionsCalendarGridView/SessionsCalendarGridView";
import { CourseViewType } from "components/classroomComponents/types";
import { useGetOrganismRoomsQuery, useGetRoomsQuery } from "store/services/teacher/classes.services";
/* import CalendarPicture from "../../../assets/images/app/calendar_teacher_icon.svg"; */

interface CustomResponse {
  statusCode: number;
  message: string;
  data: any;
}

type Props = {
  currentTeacher: any;
};

interface Niche {
  date: string;
  level: {
    _id: string;
    title: string;
    levelGroup: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  topic: {
    _id: string;
    title: string;
    level: string;
    status: string;
    position: number;
    language: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    description: string;
    price: string;
  };
  timeRanges: string[];
  idCreneau: string;
  reservations: any[];
  status: any[];
  grouplevels: any[];
  id: number;
  day: string;
  classeId: string;
  classeTitle?: string;
}

interface Obj {
  day: string;
  niches: Niche[];
}

const { Text } = Typography;
const { Option } = Select;

export const handleRemoveDoublonNiveau = (res: any[]) => {
  return res?.filter(
    (arr: any, index: number, self: any[]) =>
      index ===
      self?.findIndex(
        (t: any) =>
          t?.levelGroup === arr?.levelGroup &&
          t?.levelGroup?._id === arr?.levelGroup?._id
      )
  );
};

const MainTeacherCalendar: FC<Props> = ({ currentTeacher }) => {

  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [sendWebhook] = useWebhook();

  const { data: rooms, isLoading, isError, refetch } = useGetRoomsQuery(user?._id);
  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(user?._id);

  const [creneau, setCreneau] = useState<any>([]);
  const [index, setIndex] = useState<number>(0);
  const [allData, setAllData] = useState<any>([]);
  const [allSuccessRes, setAllSuccessRes] = useState<any>([]);
  const [allCreneaux, setAllCreneaux] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState<boolean>(true);
  const [isAllData, setIsAllData] = useState<boolean>(true);
  const [drawerRes, setDrawerRes] = useState<boolean>(false);
  const [hasCalendar, setHasCalendar] = useState<boolean>(false);
  const dateRef = useRef<(HTMLDivElement | null)[]>([]);
  const [confirmReservations, setConfirmRes] = useState<any[]>([]);

  const { isCalendarUpdated } = useSelector((state) => state.app);

  const [courseView, setCourseView] = useState<CourseViewType>('list');
  const [searchStartDate, setSearchStartDate] = useState<any>();
  const [searchEndDate, setSearchEndDate] = useState<any>();

  const [roomsData, setRoomsData] = useState<any>();
  const [filter, setFilter] = useState<any>();
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const formatDate = (date: Date) =>
    date.toISOString().split("T")[0];

  const addDays = (dateStr: string, days: number) => {
    const d = new Date(dateStr);
    d.setDate(d.getDate() + days);
    return formatDate(d);
  };

  const handleAdd30Days = () => {
    const teacherId = user?._id;
    if (!teacherId) return;

    // First load
    if (!searchStartDate) {
      const startDate = formatDate(new Date());
      const endDate = addDays(startDate, 30);

      setSearchStartDate(startDate);
      setSearchEndDate(endDate);

      fetchCalender(teacherId, startDate, endDate);
    }
    // Load More
    else {
      const newEndDate = addDays(searchEndDate, 30);

      ///setSearchStartDate(searchStartDate);
      setSearchEndDate(newEndDate);

      fetchMoreCalender(teacherId, searchStartDate, newEndDate);
    }
  };

  const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    className: s.slider,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
    afterChange: (current: number) => {
      if (current === allData.length - 4) {
        handleAdd30Days();
      }
    },
  };

  const settingsMobile = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: s.slider,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
    afterChange: (current: number) => {
      if (current === allData.length - 1) {
        handleAdd30Days();
      }
    },
  };

  const generateNiches = useCallback(
    (data: any) => {
      const niches = [];
      if (Array.isArray(data?.niches) && data?.niches?.length > 0) {
        const topics = Array.isArray(data?.niches[0]?.topic)
          ? data?.niches[0]?.topic
          : [];
        const levels = Array.isArray(data?.niches[0]?.level)
          ? data?.niches[0]?.level
          : [];
        const topicsLength = topics?.length;
        const levelsLength = levels?.length;

        for (let i = 0; i < topicsLength; i++) {
          for (let j = 0; j < levelsLength; j++) {
            const filteredTopics = data?.niches?.map((n: any) =>
              Array.isArray(n.topic) && Array.isArray(n?.level)
                ? n?.topic.filter(
                  (t: any) =>
                    t?.level === n?.level[j]._id && t?.position === i + 1
                )
                : []
            );

            const foundTopic = filteredTopics?.find((n: any) => n?.length > 0);

            if (foundTopic) {
              const niche = {
                date: data.niches[0].date,
                level: data.niches[0].level[j],
                topic: foundTopic[j],
                timeRanges: data.niches[0].timeRanges[j],
                idCreneau: data.niches[0].idCreneau,
                reservations:
                  data.niches[0] && data.niches[0].reservations
                    ? data.niches[0].reservations[j] || []
                    : [],
                status: data.niches[0].status[j] || [],
                annonce: data.annonce,
                id: j + 1,
                creneauTypes: data.niches[0].creneauTypes[j] || [],
                grouplevels: data.niches[0].grouplevels[j] || "",
                day: data.day,
                classeId: data.niches[0].classeId || "",
                classeTitle: data.niches[0].classeTitle || "",
              };
              niches.push(niche);
            }
          }
        }
      }
      const output = { day: data.day, niches: niches };
      setCreneau(output);
      return output;
    },
    [creneau]
  );

  const fetchCalender = useCallback(
    async (idTeacher: string, startDate: string, endDate: string) => {
      setLoading(true);
      if (user?._id) {
        try {
          const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?typeCreneaux=all`,
            {
              params: { startDate, endDate },
              headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
              },
            }
          );

          if (response.status === StatusCode.OK) {
            if (response?.data?.data) {
              dispatch(setUserHavingCalendar(true));
              setHasCalendar(true);

              if (isCalendarUpdated) {
                setAllData(response.data?.data);
                const result = response.data?.data
                  .filter((data: any) => data?.niches?.length > 0)
                  .map((niche: any) => generateNiches(niche));

                setAllCreneaux(result);
              }
              else {

                // Keep old data + append new
                setAllData((prev: any[]) => {
                  const merged = [...response.data?.data, ...prev];

                  // Remove duplicates by day
                  const unique = merged.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.day === item.day)
                  );

                  // Sort by date (ascending)
                  return unique.sort(
                    (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                  );
                });

                const result = response.data?.data
                  .filter((data: any) => data?.niches?.length > 0)
                  .map((niche: any) => generateNiches(niche));

                setAllCreneaux((prev: any[]) => {
                  if (prev.length === 0) {
                    // First call → just set
                    return result;
                  }
                  // Next calls → append
                  return [...prev, ...result];
                });
              }
            }
            else {
              dispatch(setUserHavingCalendar(false));
              setHasCalendar(false);
              setAllData([]);
              setAllCreneaux([]);
              setCreneau([]);
            }
          }
          else {
            dispatch(setUserHavingCalendar(false));
            setHasCalendar(false);
            setAllData([]);
            setAllCreneaux([]);
            setCreneau([]);
          }
        } catch (error) {
          dispatch(setUserHavingCalendar(false));
          setHasCalendar(false);
          setAllData([]);
          setAllCreneaux([]);
          setCreneau([]);
        } finally {
          setLoading(false);
          setLoadingMore(false);
          dispatch(setIsCalendarUpdated(false));
          setSearchStartDate(endDate);
        }
      }
    },
    [user?._id, isCalendarUpdated]
  );

  const fetchMoreCalender = async (idTeacher: string, startDate: string, endDate: string) => {
    setLoadingMore(true);
    if (user?._id) {
      try {
        const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}?typeCreneaux=all`,
          {
            params: { startDate, endDate },
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
          }
        );

        if (response.status === StatusCode.OK) {
          if (response?.data?.data) {
            dispatch(setUserHavingCalendar(true));
            setHasCalendar(true);

            if (isCalendarUpdated) {
              setAllData(response.data?.data);
              const result = response.data?.data
                .filter((data: any) => data?.niches?.length > 0)
                .map((niche: any) => generateNiches(niche));

              setAllCreneaux(result);
            }
            else {

              // Keep old data + append new
              setAllData((prev: any[]) => {
                const merged = [...response.data?.data, ...prev];

                // Remove duplicates by day
                const unique = merged.filter(
                  (item, index, self) =>
                    index === self.findIndex((t) => t.day === item.day)
                );

                // Sort by date (ascending)
                return unique.sort(
                  (a, b) => new Date(a.day).getTime() - new Date(b.day).getTime()
                );
              });

              const result = response.data?.data
                .filter((data: any) => data?.niches?.length > 0)
                .map((niche: any) => generateNiches(niche));

              setAllCreneaux((prev: any[]) => {
                if (prev.length === 0) {
                  // First call → just set
                  return result;
                }
                // Next calls → append
                return [...prev, ...result];
              });
            }
          }
          else {
            dispatch(setUserHavingCalendar(false));
            setHasCalendar(false);
            setAllData([]);
            setAllCreneaux([]);
            setCreneau([]);
          }
        }
        else {
          dispatch(setUserHavingCalendar(false));
          setHasCalendar(false);
          setAllData([]);
          setAllCreneaux([]);
          setCreneau([]);
        }
      } catch (error) {
        dispatch(setUserHavingCalendar(false));
        setHasCalendar(false);
        setAllData([]);
        setAllCreneaux([]);
        setCreneau([]);
      } finally {
        setLoadingMore(false);
        dispatch(setIsCalendarUpdated(false));
        setSearchStartDate(endDate);
      }
    }
  };

  useEffect(() => {
    if (currentTeacher) {
      handleAdd30Days();
    }
  }, [currentTeacher]);

  useEffect(() => {
    if (isCalendarUpdated) {
      fetchCalender(user?._id, searchStartDate, searchEndDate);
    }
  }, [isCalendarUpdated]);

  useEffect(() => {
    const filterReservations = (allCreneaux: any[]): any[] => {
      const reservations: any[] = allCreneaux.filter((creneau: any) => {
        return creneau.niches.some((niche: any) => {
          return niche.reservations && niche.reservations._id;
        });
      });

      const successReservations: any[] = reservations.reduce(
        (acc: any[], creneau: any) => {
          const niche = creneau.niches[0];
          if (niche.reservations) {
            acc.push({
              ...niche.reservations,
              topic: niche.topic,
            });
          }
          return acc;
        },
        []
      );

      return successReservations;
    };

    const myReservations: any[] = filterReservations(allCreneaux);

    setAllSuccessRes((res: any) => [...res, myReservations]);
  }, [allCreneaux]);

  useEffect(() => {
    if (allCreneaux && allCreneaux?.length > 0) {
      setFilteredData(allCreneaux);
    }
  }, [allCreneaux]);

  useEffect(() => {
    if (isLoading || loadingOrganismRooms) return;

    const merged = [...rooms.data, ...organismRooms.data];

    const unique = merged.filter(
      (room, index, self) =>
        index === self.findIndex((r) => r._id === room._id)
    );

    setRoomsData(unique);
  }, [rooms?.data, organismRooms?.data]);

  const handleFiltering = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredData(allCreneaux);
      return;
    }

    let filtered = allCreneaux;

    if (value === 'all') {
      setFilteredData(allCreneaux);
    }
    else if (value === 'particular') {
      filtered = allCreneaux.filter(
        (session: any) =>
          session.niches[0]?.classeId === "" || session.niches[0]?.classeId === undefined || session.niches[0]?.classeId === null
      );

      setFilteredData(filtered);
    }
    else {
      filtered = allCreneaux.filter(
        (session: any) =>
          session.niches[0]?.classeId &&
          session.niches[0]?.classeId === value
      );
      setFilteredData(filtered);
    }

  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <div style={{ display: "flex", flexDirection: "column", paddingTop: isMobile ? 50 : 20, paddingLeft: isMobile ? 10 : 20, paddingRight: isMobile ? 10 : 20, paddingBottom: 20 }}>
      {isMobile ? <div className={s.headerBox}>
        {/* <div className={s.headerBoxTitleFull}>
          <div className={s.titleBox}>
            <div className={s.titlePictureBox}>
              <img src={CalendarPicture} height={isMobile ? 10 : 25}></img>
            </div>
            Mon calendrier
            <div style={{ marginLeft: "10px", marginTop: "5px" }}>
              <HelpPopover id={"dashboard_mon_calendrier"} />
            </div>
          </div>
        </div> */}

        <div className={s.headerBoxTitle} style={{ marginTop: "15px" }}>
          <Space style={{ marginLeft: "10px" }}>
            {courseView === 'calendar' && <Button
              type={'default'}
              onClick={() => setCourseView('list')}
              style={{ borderRadius: '20px' }}
            >
              Vue par liste
            </Button>}
            {courseView !== 'calendar' && <Button
              type={'default'}
              onClick={() => setCourseView('calendar')}
              style={{ borderRadius: '20px' }}
            >
              Vue calendrier
            </Button>}
          </Space>

          {isAllData && <Select
            value={filter}
            onChange={(value) => handleFiltering(value)}
            className="select-filter"
            placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
          >
            {roomsData?.map((room: any, index: number) => (
              <Option key={index} value={room?._id}>{room?.title}</Option>
            ))}
            <Option value="particular">Cours particulier</Option>
            <Option value="all">Toutes les disponibilités</Option>
          </Select>}
        </div>

        <div className={s.buttonBox}>
          {hasCalendar && <Button icon={<PlusOutlined />} className={s.addButton} onClick={() => dispatch(displayDrawerAdsSpecific(true))}>
            Créneau unique ponctuel
          </Button>}
          <Button className={s.gestionButton} onClick={() => dispatch(displayDrawer(true))}>
            Gestion des créneaux récurrents
          </Button>
        </div>
      </div> : <div className={s.headerBox}>
        <div className={s.titleBox}>
          {/* <div className={s.titlePictureBox}>
            <img src={CalendarPicture} height={isMobile ? 10 : 25}></img>
          </div>
          Mon calendrier
          <div style={{ marginLeft: "10px", marginTop: "5px" }}>
            <HelpPopover id={"dashboard_mon_calendrier"} />
          </div> */}

          <Space style={{ marginLeft: "0px" }}>
            {courseView === 'calendar' && <Button
              type={'default'}
              onClick={() => setCourseView('list')}
              style={{ borderRadius: '20px' }}
            >
              Vue par liste
            </Button>}
            {courseView !== 'calendar' && <Button
              type={'default'}
              onClick={() => setCourseView('calendar')}
              style={{ borderRadius: '20px' }}
            >
              Vue calendrier
            </Button>}
          </Space>

          {isAllData && <Select
            value={filter}
            onChange={(value) => handleFiltering(value)}
            className="select-filter"
            placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
          >
            {roomsData?.map((room: any, index: number) => (
              <Option key={index} value={room?._id}>{room?.title}</Option>
            ))}
            <Option value="particular">Cours particulier</Option>
            <Option value="all">Toutes les disponibilités</Option>
          </Select>}
        </div>

        <div className={s.buttonBox}>
          {hasCalendar && <Button icon={<PlusOutlined />} className={s.addButton} onClick={() => dispatch(displayDrawerAdsSpecific(true))}>
            Créneau unique ponctuel
          </Button>}
          <Button className={s.gestionButton} onClick={() => dispatch(displayDrawer(true))}>
            Gestion des créneaux récurrents
          </Button>
        </div>
      </div>}

      {courseView === 'list' ? <>
        {allData?.length > 0 && <div className={s.weekBox}>
          <div style={{ width: "5%" }}>
            <Button
              onClick={() => {
                setConfirmRes([]);
                setIsAllData(true);
              }}
              style={{ height: isMobile ? "25px" : "35px", backgroundColor: isAllData ? "var(--first-color)" : "transparent", color: isAllData ? "#fff" : "#333", borderRadius: isMobile ? "12px" : "16px", fontSize: isMobile ? "0.8em" : "14px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              Afficher tout
            </Button>
          </div>
          <div style={{ width: isMobile ? "50%" : "83%", marginRight: isMobile ? "25px" : "20px" }}>
            {!isMobile && <Slider {...settings}>
              {allData?.map((item: any, index: number) => (
                <div
                  key={index}
                  ref={(el) => (dateRef.current[index] = el)}
                  onClick={() => {
                    generateNiches(item);
                    setConfirmRes([]);
                    setIndex(index);
                    setIsAllData(false);
                  }}
                  className={`${s.date} ${creneau?.day === item?.day && s.active}`}
                >
                  <span>{moment(item?.day).format('dddd D MMMM YYYY')}</span>
                </div>
              ))}
            </Slider>}
            {isMobile && <Slider {...settingsMobile}>
              {allData?.map((item: any, index: number) => (
                <div
                  key={index}
                  ref={(el) => (dateRef.current[index] = el)}
                  onClick={() => {
                    generateNiches(item);
                    setConfirmRes([]);
                    setIndex(index);
                    setIsAllData(false);
                  }}
                  className={`${s.date} ${creneau?.day === item?.day && s.active}`}
                >
                  <span>{moment(item?.day).format('dddd D MMMM YYYY')}</span>
                </div>
              ))}
            </Slider>}
          </div>
        </div>}

        {loading ? (
          <>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </>
        ) : (
          <Fragment>
            {!loading && allData?.length > 0 ? (
              <div className={s.calendarBox}>
                {isAllData ? (
                  filteredData?.map((cren: any, index: number) => {
                    return (
                      cren?.niches[0]?.idCreneau !== undefined && <div key={index} style={{ marginBottom: "20px" }}>
                        <div className={s.dateBox}>
                          {new Intl.DateTimeFormat("fr-FR", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          }).format(new Date(cren?.day))}
                          {isToday(cren?.day) && <div className={s.todayBox}>Aujourd’hui</div>}
                          <div className={s.horizontalLine}></div>
                        </div>

                        {isMobile && <div className={s.cardTime}>
                          {cren?.niches?.map((c: any, index: number) => {
                            return (
                              <CardCreneau
                                isAllReservation={false}
                                key={index}
                                cren={c}
                                index={index}
                                currentTeacher={currentTeacher}
                                confirmReservations={confirmReservations}
                                setConfirmRes={setConfirmRes}
                                showReserved={false}
                              />
                            );
                          })}
                        </div>}
                        {!isMobile && cren?.niches?.map((c: any, index: number) => {
                          return (
                            <CardCreneau
                              isAllReservation={false}
                              key={index}
                              cren={c}
                              index={index}
                              currentTeacher={currentTeacher}
                              confirmReservations={confirmReservations}
                              setConfirmRes={setConfirmRes}
                              showReserved={false}
                            />
                          );
                        })}
                      </div>
                    )
                  })
                ) : (
                  <div>
                    <div className={s.dateBox}>
                      {new Intl.DateTimeFormat("fr-FR", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }).format(new Date(creneau?.day))}
                      {isToday(creneau?.day) && <div className={s.todayBox}>Aujourd’hui</div>}
                      <div className={s.horizontalLine}></div>
                    </div>

                    {creneau?.niches?.length <= 0 ? (
                      <AppResult
                        status="info"
                        title={`Tu n'as aucune disponibilité pour le ${moment(
                          creneau?.day
                        ).format("LL")}`}
                      />
                    ) : (
                      <Fragment>
                        {isMobile && <div className={s.cardTime}>
                          {creneau?.niches?.map((cren: any, index: number) => {
                            return (
                              <CardCreneau
                                key={index}
                                cren={cren}
                                index={index}
                                isAllReservation={false}
                                currentTeacher={currentTeacher}
                                confirmReservations={confirmReservations}
                                setConfirmRes={setConfirmRes}
                                showReserved={false}
                              />
                            );
                          })}
                        </div>}
                        {!isMobile && creneau?.niches?.map((cren: any, index: number) => {
                          return (
                            <CardCreneau
                              key={index}
                              cren={cren}
                              index={index}
                              isAllReservation={false}
                              currentTeacher={currentTeacher}
                              confirmReservations={confirmReservations}
                              setConfirmRes={setConfirmRes}
                              showReserved={false}
                            />
                          );
                        })}
                      </Fragment>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <AppResult
                status={"info"}
                title="Tu n'as aucune disponibilité"
                isMobile={isMobile ? true : false}
              />
            )}
          </Fragment>
        )}

        {!loadingMore && allData?.length > 0 && (
          <Button className={s.newButton} onClick={() => window.location.reload()}>
            Recharger le calendrier
          </Button>
        )}
      </> : filteredData?.length > 0 ? <SessionsCalendarGridView
        dayData={filteredData}
        showFilter={false}
        isTeacherCalendar={true}
      /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>}

      <TeacherCalendarDetails
        currentTeacher={currentTeacher}
        drawerRes={drawerRes}
        allSuccessRes={allSuccessRes}
        setDrawerRes={setDrawerRes}
      />
      <DrawerAdsCreneauSpecific />
    </div>
  );
};

export default MainTeacherCalendar;
